const localeUtils = require('utils/LanguageLocale');

let getBasketConst = () => {
    const getText = localeUtils.getLocaleResourceFile(
        'constants/locales',
        'Basket'
    );

    return {
        MESSAGES: {
            BASKET_LEVEL: {
                FREE_SHIPPING: getText('freeShipping'),
                ROUGE_FREE_SHIPPING: getText('rougeFreeShipping'),
                ROW_FREE_SHIPPING: getText('rowFreeShipping'),
                FREE_FLASH_SHIPPING: getText('freeFlashShipping')
            },
            ALREADY_SUBSCRIBED_TO_FLASH: getText('alreadySubscribedToFlash'),
            ROUGE_ENROLLED_FOR_FREE: getText('rougeEnrolledForFree')
        },
        CONTEXT: { RW_REMAINING_BALANCE: 'basket.rwRemainingBalance' },
        // The minimum points at which a reward is valuable enough to be shipping without a product
        // also being in the order
        STANDALONE_REWARD_MIN_VAL: 750,
        // Warning messages (key/messageContext) we don't want to show in the Inline Basket and show them
        // in a different way in Basket page list item
        WARNING_BLACKLIST_MESSAGES: [
            'vibFreeShipping.alreadyEnrolledInFlashOneTime',
            'vibFreeShipping.alreadyEnrolledInFlashAR',
            'flash.subscribedAutoRenew',
            'flash.subscribedOneTime',
            'vibFreeShipping.enrollingInFlash'
        ],
        SHOPPING_LIST_PROMO_WARNING: 'shoppingList.promoWarning',
        //Message that must be shown in mobile when present
        ALREADY_ENROLLED_IN_FLASH: 'vibFreeShipping.alreadyEnrolledInFlash',
        //Message that must be shown in the inline basket
        FLASH_CLASHES_WITH_REWARD: 'basket.flashSubscriptionClashesWithFlashReward',
        PROMO_WARNING: 'basket.promoWarning',
        RESTRICTED_ITEMS_REMOVED: 'basket.restrictedItemsRemoved',
        GET_IT_SHIPPED_WARNING: 'basket.shiptoHome.genericErrorMessage',
        PICK_UP_IN_STORE_WARNING: 'basket.pickupItems.genericErrorMessage',
        PICK_UP_IN_STORE_ON_HOLD: 'basket.pickupStoreReservationOnHold',
        PICK_UP_ITEMS_OUT_OF_STOCK: 'basket.pickupItemsOutOfStock',
        PICK_UP_ITEMS_OUT_OF_STOCK_SKU: 'basket.pickupsku.outOfStock',
        FREE_SHIPPING_THRESHOLD: 'basket.thresholdFreeShipping',
        FREE_SHIPPING_ROUGE: 'basket.rougeFreeShipping',
        FREE_SHIPPING_ROUGE_CA: 'basket.rougeCAFreeShipping',
        FREE_SHIPPING_ROUGE_FLASH: 'basket.rougeFlashFreeShipping',
        FREE_SHIPPING_ROUGE_HAZMAT: 'basket.rougeHazmatFreeShipping',
        FREE_SHIPPING_FLASH: 'basket.flashFreeShipping',
        FREE_SHIPPING_FLASH_HAZMAT: 'basket.flashHazmatFreeShipping',
        CBR_PROMO_MESSAGE: 'basket.promoMessages.cbr',
        PFD_PROMO_MESSAGE: 'basket.promoMessages.pfd'
    };
};

module.exports = getBasketConst();
